import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const GET_INCIDENT_VORLAGEN_LISTE = '[IncidentsModul] GetIncidentVorlagenListe laden';
export const GET_INCIDENT_VORLAGEN_LISTE_AUSFUEHREN = '[IncidentsModul] GetIncidentVorlagenListe ausführen';
export const GET_INCIDENT_VORLAGEN_LISTE_ERFOLGREICH = '[IncidentsModul] GetIncidentVorlagenListe laden erfolgreich';
export const GET_INCIDENT_VORLAGEN_LISTE_FEHLER = '[IncidentsModul] GetIncidentVorlagenListe Ladefehler';
export const GET_INCIDENT_VORLAGEN_LISTE_NICHT_AUSGEFUEHRT = '[IncidentsModul] GetIncidentVorlagenListe nicht ausgeführt (evtl. Offline)';


export class GetIncidentVorlagenListeAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_LISTE;
        constructor(public optPayload: any = null) {}
    }
export class GetIncidentVorlagenListeAusfuehrenAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_LISTE_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetIncidentVorlagenListeErfolgreichAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_LISTE_ERFOLGREICH;
        constructor(public payload: Array<api.IncidentVorlageDetail>, public optPayload: any = null) {}
    }
export class GetIncidentVorlagenListeFehlerAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_LISTE_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetIncidentVorlagenListeNichtAusgefuehrtAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_LISTE_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsQueryIncidentVorlagenListeActions =
    GetIncidentVorlagenListeAction
    | GetIncidentVorlagenListeAusfuehrenAction
    | GetIncidentVorlagenListeErfolgreichAction
    | GetIncidentVorlagenListeFehlerAction
    | GetIncidentVorlagenListeNichtAusgefuehrtAction
    ;
